import { LogEventType } from '@akin-home/amplify';
import { ViewRecordLogEvent } from '@akin-home/logging';
import { postLogEvent } from './postLogEvent';

interface Params {
  user_id: string;
  data: ViewRecordLogEvent['data'];
}

export const postViewRecordLogEvent = (params: Params) =>
  postLogEvent({
    type: LogEventType.VIEW_RECORD,
    ...params,
  });
